require('./accountDirectDebitStep1.scss');

//@vendors
const React = require('react');

//@helpers
const { FormattedText } = require('core/i18n').i18n;

//@constants
const {
    ACCOUNT_DIRECT_DEBIT_DOWNLOAD_DEBIT_FORMAT_PDF_URL,
    ACCOUNT_DIRECT_DEBIT_EMAILID
} = require('constants/accountDirectDebit');

//@commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');

class AccountDirectDebitStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.buildModalBody = this.buildModalBody.bind(this);
    }

    buildModalBody() {
        const ordinaryMailBullet = [
            {text: 'ordinaryMailBullet1Text'},
            {text: 'ordinaryMailBullet2Text'},
            {text: 'ordinaryMailBullet3Text'}
        ];
        const ordinaryMailBulletHTML = this.createList(ordinaryMailBullet, 'account-direct-debit-step1__content-list', 'accountDirectDebitStep1');

        const popupEmailBullet = [
            {text: 'popupEmailBullet1Text'},
            {text: 'popupEmailBullet2Text'},
            {text: 'popupEmailBullet3Text'}
        ];
        const popupEmailBulletHTML = this.createList(popupEmailBullet, 'account-direct-debit-step1__content-list', 'accountDirectDebitStep1');

        return(
            <div className="account-direct-debit-step1__content">
                <h2 className="account-direct-debit-step1__content-title">
                    <FormattedText value="accountDirectDebitStep1-popupTitle"/>
                </h2>
                <FormattedText
                    className="account-direct-debit-step1__content-email"
                    value="accountDirectDebitStep1-popupEmailHeading"
                />
                {popupEmailBulletHTML}
                <div className="account-direct-debit-step1__content-section">
                    <FormattedText
                        className="account-direct-debit-step1__content-email"
                        value="accountDirectDebitStep1-ordinaryMailHeading"
                    />
                    {ordinaryMailBulletHTML}
                </div>
                <div className="account-direct-debit-step1__content-download">
                    <OKButton
                        to={ACCOUNT_DIRECT_DEBIT_DOWNLOAD_DEBIT_FORMAT_PDF_URL}
                        modifier="task"
                        size="compact"
                    >
                        <i className="icon-descargar" />
                    </OKButton>
                    <FormattedText
                        className="account-direct-debit-step1__content-download-title"
                        value="accountDirectDebitStep1-downloadDocumentText"
                    />
                </div>
            </div>
        );
    }

    handleToggleModal(e) {
        if (!!e) {
            e.preventDefault();
        }
        this.setState ({
            showModal: !this.state.showModal
        });
    }

    createList(listArray, listClass, textPrefix) {
        let list;
        list = listArray.map((item, index) => {
            let element;
            if(item.hasLink) {
                element = (
                    <a
                        className="ok-link ok-link--emphasize"
                        target="_blank"
                        href={`mailto:${ACCOUNT_DIRECT_DEBIT_EMAILID}`}
                    >
                        {ACCOUNT_DIRECT_DEBIT_EMAILID}
                    </a>
                );
            }
            return (
                <li key={index}>
                    <FormattedText value={`${textPrefix}-${item.text}`}/>
                    {element}
                </li>
            );
        });
        if(list.length > 0) {
            return (
                <ul className={listClass}>
                    {list}
                </ul>
            );
        }
    }

    render() {
        const modalBody = this.buildModalBody();
        const requestStepsBullet = [
            {text: 'bullet1text'},
            {text: 'bullet2text'},
            {text: 'bullet3text'}
        ];
        const requestStepsBulletHTML = this.createList(requestStepsBullet, 'account-direct-debit-step1__request-steps', 'accountDirectDebitStep1');

        return (
            <div className="account-direct-debit-step1">
                <h2 className="account-direct-debit-step1__title">
                    <FormattedText value="accountDirectDebitStep1-title"/>
                </h2>
                {requestStepsBulletHTML}
                <span className="account-direct-debit-step1__modal-popup">
                    <FormattedText value="accountDirectDebitStep1-popupLinkText"/>
                    <OKLink
                        modifier="emphasize"
                        onClick={this.handleToggleModal}
                        to="javascript:void(0);"
                    >
                        <FormattedText value="accountDirectDebitStep1-popupLink"/>
                    </OKLink>
                </span>
                <OKModal
                    content={modalBody}
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleToggleModal}
                />
            </div>
        );
    }
}

module.exports = AccountDirectDebitStep1;
